abstract class AbstractProcesser {
  abstract process(): void
}

export default AbstractProcesser
